/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mcp_Server_Development_Tlm_2Inputs */

const en_svc_mcp_server_development_tlm_2 = /** @type {(inputs: Svc_Mcp_Server_Development_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`api_surface`)
};

const ar_svc_mcp_server_development_tlm_2 = /** @type {(inputs: Svc_Mcp_Server_Development_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سطح الواجهة البرمجية`)
};

const bn_svc_mcp_server_development_tlm_2 = /** @type {(inputs: Svc_Mcp_Server_Development_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`api_surface`)
};

const de_svc_mcp_server_development_tlm_2 = /** @type {(inputs: Svc_Mcp_Server_Development_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`api_surface`)
};

const es_svc_mcp_server_development_tlm_2 = /** @type {(inputs: Svc_Mcp_Server_Development_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`api_superficie`)
};

const fr_svc_mcp_server_development_tlm_2 = /** @type {(inputs: Svc_Mcp_Server_Development_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`api_surface`)
};

const pt_svc_mcp_server_development_tlm_2 = /** @type {(inputs: Svc_Mcp_Server_Development_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`superfície_api`)
};

const zh_svc_mcp_server_development_tlm_2 = /** @type {(inputs: Svc_Mcp_Server_Development_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`api_surface`)
};

const tr_svc_mcp_server_development_tlm_2 = /** @type {(inputs: Svc_Mcp_Server_Development_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`api_surface`)
};

const ru_svc_mcp_server_development_tlm_2 = /** @type {(inputs: Svc_Mcp_Server_Development_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`api_surface`)
};

const pl_svc_mcp_server_development_tlm_2 = /** @type {(inputs: Svc_Mcp_Server_Development_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`api_surface`)
};

/**
* | output |
* | --- |
* | "api_surface" |
*
* @param {Svc_Mcp_Server_Development_Tlm_2Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mcp_server_development_tlm_2 = /** @type {((inputs?: Svc_Mcp_Server_Development_Tlm_2Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mcp_Server_Development_Tlm_2Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mcp_server_development_tlm_2(inputs)
	if (locale === "bn") return bn_svc_mcp_server_development_tlm_2(inputs)
	if (locale === "de") return de_svc_mcp_server_development_tlm_2(inputs)
	if (locale === "es") return es_svc_mcp_server_development_tlm_2(inputs)
	if (locale === "fr") return fr_svc_mcp_server_development_tlm_2(inputs)
	if (locale === "pt") return pt_svc_mcp_server_development_tlm_2(inputs)
	if (locale === "zh") return zh_svc_mcp_server_development_tlm_2(inputs)
	if (locale === "tr") return tr_svc_mcp_server_development_tlm_2(inputs)
	if (locale === "ru") return ru_svc_mcp_server_development_tlm_2(inputs)
	if (locale === "pl") return pl_svc_mcp_server_development_tlm_2(inputs)
	return en_svc_mcp_server_development_tlm_2(inputs)
});
export { svc_mcp_server_development_tlm_2 as "svc_mcp-server-development_tlm_2" }